import { FilterModuleConfig, FilterOption } from './types'

export function transformToGenericFilterConfig(
    config: Record<string, any>,
    defaultFilters: Record<string, any>
): Record<string, FilterModuleConfig> {
    const result: Record<string, FilterModuleConfig> = {}

    Object.keys(config).forEach((key) => {
        const sectionConfig = config[key]
        const sectionDefaultFilters = defaultFilters[key]

        // Transform the filters to include id property
        const transformedConfig: Record<string, any> = {}
        Object.keys(sectionConfig).forEach((filterType) => {
            const filterSection = sectionConfig[filterType]
            const filters: Record<string, FilterOption> = {}

            Object.keys(filterSection.filters).forEach((filterKey) => {
                const filterOption = filterSection.filters[filterKey]
                filters[filterKey] = {
                    id: filterKey,
                    label: filterOption.label,
                    icon: filterOption.icon,
                    accessor: filterOption.accessor || filterKey,
                }
            })

            transformedConfig[filterType] = {
                ...filterSection,
                filters,
            }
        })

        result[key] = {
            config: transformedConfig,
            defaultFilters: sectionDefaultFilters,
        }
    })

    return result
}
